<template>
  <v-card @click="goToReport">
    <v-card-text>
      <v-row>
        <v-col cols="auto">
          <span v-html="category.icon" class="text-h6"></span>
        </v-col>
        <v-col>
          <div v-html="text(insight.text)"></div>
          <div class="caption font-italic">
            <template v-if="insight.startDate && insight.endDate">
              <template
                v-if="insight.compareStartDate && insight.compareEndDate"
              >
                {{ range(insight.compareStartDate, insight.compareEndDate) }}
                vs.
              </template>
              {{ range(insight.startDate, insight.endDate) }}
            </template>
            <template v-else>
              {{ insight.createdDate | longDate }}
            </template>
            <v-icon
              v-if="insight.readDate"
              color="lighttext"
              small
              class="pl-2"
            >
              visibility
            </v-icon>
          </div>
        </v-col>
        <v-spacer class="limited-spacer"></v-spacer>
        <v-col cols="auto">
          <v-menu absolute>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon>
                <v-icon>more_vert</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="goToReport">
                <v-list-item-title>View</v-list-item-title>
              </v-list-item>
              <v-list-item @click="dismiss">
                <v-list-item-title>Dismiss</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "InsightCard",
  props: { insight: { type: Object } },
  computed: {
    text() {
      return t => {
        return t
          .replace("[b]", "<span class='font-weight-bold'>")
          .replace("[/b]", "</span>")
          .replace("[u]", "<span class='text-decoration-underline'>")
          .replace("[/u]", "</span>");
      };
    },
    range() {
      return (s, e) => {
        let start = moment(s);
        let end = moment(e);
        if (start.year() != end.year()) {
          return `${start.format("MMM D, YYYY")}-${end.format("MMM D, YYYY")}`;
        } else if (start.month() != end.month()) {
          return `${start.format("MMM D")}-${end.format("MMM D")}, ${end.format(
            "YYYY"
          )}`;
        } else {
          return `${end.format("MMM")}${start.format("D")}-${end.format(
            "D"
          )}, ${end.format("YYYY")}`;
        }
      };
    },
    category() {
      return this.insight_categories.find(
        x => x.id == this.insight.type.categoryId
      );
    },
    link() {
      if (!this.insight.reportLink) {
        return null;
      }
      let link = `/reporting/${this.insight.reportLink}`;
      if (this.insight.teamId) {
        link += `/departments/${this.insight.teamId}`;
      } else if (
        this.insight.type.targetId == this.$enums.insightTargets.MEMBERS
      ) {
        link += "/members";
      }
      return link;
    },
    sortBy() {
      if (this.insight.type.changeId == this.$enums.insightChangeTypes.VALUE) {
        if (
          this.insight.type.coreCardTypeId ==
          this.$enums.coreCardTypes.ENGAGEMENT
        ) {
          return "userRecords.value.completion";
        } else {
          return "score.value";
        }
      } else if (
        this.insight.type.changeId == this.$enums.insightChangeTypes.PERCENTAGE
      ) {
        if (
          this.insight.type.coreCardTypeId ==
          this.$enums.coreCardTypes.ENGAGEMENT
        ) {
          return "userRecords.percentChange";
        } else {
          return "score.percentChange";
        }
      }
      return null;
    },
    sortDesc() {
      if (
        this.insight.type.categoryId == this.$enums.insightCategories.CELEBRATE
      ) {
        return true;
      }
      return false;
    },
    ...mapGetters({
      insight_categories: "lookup/insight_categories"
    })
  },
  methods: {
    goToReport() {
      if (!this.link) {
        return;
      }
      this.$store.dispatch("insights/markInsightRead", this.insight.id);
      let filter =
        this.insight.startDate && this.insight.endDate
          ? {
              timeframeId: this.$enums.timeframes.CUSTOM,
              customStartDate: moment.utc(this.insight.startDate).local(),
              customEndDate: moment.utc(this.insight.endDate).local(),
              customTimezone: moment.tz.guess(true)
            }
          : { timeframeId: this.$enums.timeframes.ALL_TIME };
      let callArray = [
        this.$store.dispatch("reporting/setTimeframe", filter),
        this.$store.dispatch("reporting/setSortBy", this.sortBy),
        this.$store.dispatch("reporting/setSortDesc", this.sortDesc)
      ];
      Promise.all(callArray).then(() => {
        this.$router.push({ path: this.link });
      });
    },
    dismiss() {
      this.$store.dispatch("insights/deleteInsight", this.insight.id);
    }
  }
};
</script>
